import React, { Fragment, useState, useEffect, useRef } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { useTranslation } from "react-i18next";
import {
  Container,
  Form,
  Row,
  Col,
  Card,
  Button,
  CardBody,
} from "react-bootstrap";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import Lightbox from 'react-image-lightbox';
import hotelimg from "../imagepreview.png"
import 'react-image-lightbox/style.css';

import "./hoteldetails.css";



const { config } = require("../api/api");


function ShowBuyHotel() {
  const base_url = config.baseURL;
  const redirect_url = config.redirectURL;
  const lnstr = Cookies.get("langData") ? Cookies.get("langData") : "en";
  const [loading, setLoading] = useState(true);

  const { t } = useTranslation();
  const [etmToken, setEtmToken] = useState(null);
  const [vendorKey, setVendorkey] = useState("");

  const [Hotel_id, setHotel_id] = useState("");

  const [showUploadModal, setShowUploadModal] = useState(false);

  const [hotelImage, setHotelImage] = useState(null);
  const [hotellist, setHotellist] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [roomImage, setRoomImage] = useState({});
  const [currentHotelId, setCurrentHotelId] = useState(null);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [messsagePopup,setMessagePopup]=useState('');
  const [amenities,setAmenities]=useState([]);
  const [facilitiesPopup,setFacilitiesPopup]=useState(false);

  useEffect(() => {
    if (showUploadModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showUploadModal]);

  useEffect(() => {
    const createOrganization = async () => {
      try {
        const postvData = { organization_name: "Superjet" };

        const response = await fetch(base_url + "/create_organization", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(postvData),
        });
        const data = await response.json();
        setVendorkey(data.result[0].vendor_key);
      } catch (error) {
        console.error("Error posting data:", error);
      }
    };

    if (!vendorKey) {
      createOrganization();
    }
  }, [vendorKey, base_url]);

  useEffect(() => {
    const storedData = Cookies.get("auth_key");
    if (storedData !== undefined) {
      const storedtoken = JSON.parse(storedData);
      setEtmToken(storedtoken);
    } else {
      // alert("token expired");
      // window.location.href='/';
    }
  },[])



      
  
    

  const StarRating = ({ rating, totalStars = 5 }) => {
    const filledStars = Math.round(rating);
    const emptyStars = totalStars - filledStars;

    return (
      <div className="star-rating" style={{ display: "flex", padding: "0" }}>
        {[...Array(filledStars)].map((_, index) => (
          <span
            key={`filled-${index}`}
            //   onClick={() => handleStarClick(index)}
            style={{ color: "gold", cursor: "pointer" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-star-fill"
              viewBox="0 0 16 16"
            >
              <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
            </svg>
          </span>
        ))}
        {[...Array(emptyStars)].map((_, index) => (
          <span
            key={`empty-${index}`}
            //   onClick={() => handleStarClick(filledStars + index)}
            style={{ color: "gray", cursor: "pointer" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-star"
              viewBox="0 0 16 16"
            >
              <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
            </svg>
          </span>
        ))}
      </div>
    );
  };

  useEffect(() => {
    if (showUploadModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showUploadModal]);

  const showPaymentPage = (e, offer_id) => {
    e.preventDefault();

    sessionStorage.setItem("offerTimer", 15 * 60);

    sessionStorage.setItem("Offer_id", offer_id); 

    
    window.location.href = "/hotel-booking";
  };

  useEffect(() => {
    const getETMData = sessionStorage.getItem("ETM_Data");
    const parseData = getETMData ? JSON.parse(getETMData) : null;

    const getHotelOfferDetails = async () => {
      const getETMData = sessionStorage.getItem("ETM_Data");
      const parseData = getETMData ? JSON.parse(getETMData) : null;
      var hotel_id = parseData.hotel_id;

      var etmToken = parseData.etmtoken;
      setHotel_id(hotel_id);

      const setData = {
        etmtoken: etmToken,
        hotel_id: hotel_id,
      };
      try {
        const response = await fetch(base_url + "/hotel_offer", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + vendorKey,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(setData),
        });
        if (!response.ok) {
          console.log("http response status : ", response.status);
        } else {
          const data = await response.json();

          if (data.message === "success") {
            const modify_data = data.result.data.map((dataObj) => {
              return {
                ...dataObj,
                rooms: JSON.stringify(dataObj.rooms),
              };
            });
  // setroomImage((prev) => ({
  //                   ...prev,
  //                   []: data.result.images
  //                 }));

debugger
data.result.data.forEach((obj) => {
  setRoomImage((prev) => ({
    ...prev,
    [obj.rooms[0].offer_id]: obj.rooms.flatMap((room) => room.images)
  }));
});


            setHotellist(modify_data);
            setHotelImage(parseData.hotel_img);
          }
        }
      } catch (err) {
        console.log("Hotel Show Offer API Err : ", err);
      
      }
     finally{
      setTimeout(()=>{
         setLoading(false);
      },2000)
     }
    };
    if (parseData !== undefined && vendorKey) {
      getHotelOfferDetails();
    }
  }, [vendorKey]);


const handleOpenImageViewer = (offerId) => {
debugger
  setCurrentHotelId(offerId);
  setPhotoIndex(0); // reset to first image
  setIsOpen(true);
};


const handleShowFacilities=(amenities_names)=>{
  setAmenities(amenities_names);
  setFacilitiesPopup(true);
}

const handleClose=()=>{
   setAmenities([]);
  setFacilitiesPopup(false);
}

  return (
    <Fragment>
      <div className="header_section1">
        <Navbar />

        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">
              {lnstr === "en" ? "e-Hotel Offers" : "عروض الفنادق الإلكترونية\n"}
            </h3>
          </div>
        </div>
      </div>

      <div className="features_section" dir="ltr">
        <div className="container">
          <div className="row">
            <Col md={1}> </Col>

            <Col md={10} className="myforms my-5">
              <br />
              {hotellist.map((room, index) => (
                <div>
                  {JSON.parse(room.rooms).length > 0 ? (
                    <div className="card shadow mb-4">
                      <div className="card-header">
                        <div className="row">
                          <div className="col-md-2 ">
                           {[JSON.parse(room.rooms)[0]].map(
                            (roomobj, room_index) => (
                              <>
                               <div style={{position:"relative",cursor:"pointer"}} 
                               onClick={()=>{
                                if(roomobj.images.length>0){
                                handleOpenImageViewer(roomobj.offer_id)
                                }}
                                }>
              <img
                src={roomobj.images.length>0?roomobj.images[0].url : hotelImage}
                alt={""}
                style={{ objectFit: 'cover', width: '200px', height: '100px' }}
                className="hotel-img"
                // className="hotel-room-mobile"
              />
              {/* <div class="hotel-info-image__images-number">
            +85
          </div> */}
             {roomobj.images.length>0 && <div
                style={{
                  position: 'absolute',
                  bottom: '5px',
                  left: '5px',
                  backgroundColor: 'rgba(0, 0, 0, 0.6)',
                  color: 'white',
                  padding: '2px 6px',
                  fontSize: '12px',
                  borderRadius: '3px',
                }}
              >
                <span><img src={hotelimg} alt="image_icon" width="13" height="10" style={{ filter: 'invert(1)' }}/></span>
                +{roomobj.images.length}
              </div>
              }

            </div>

                            </>
                            ))}
                          </div>
                          {[JSON.parse(room.rooms)[0]].map(
                            (roomobj, room_index) => (
                              <>
                                <div className=" col-md-10  mt-2 mt-md-0">
                                  {(() => {
                                    const rooms = JSON.parse(room.rooms);
                                    const last_index = rooms.length;
                                    const room_name =
                                      rooms[rooms.length - 1].class;

                                    return (
                                      <h4>
                                        <span
                                          className=""
                                          style={{
                                            borderRadius: "5px",
                                            display: "inline-block",
                                            backgroundColor: "#666666",
                                            padding: "0px 8px",
                                            color: "#fff",
                                            fontSize: "19px",
                                          }}
                                        >
                                          {last_index + "x"}
                                        </span>
                                        &nbsp;{room_name}
                                      </h4>
                                    );
                                  })()}
                               

                                 
                                  <div className="d-flex"> 
                                   
                                    {(() => {
                                      const rooms = JSON.parse(room.rooms);

                                      return rooms.map((room, i) => {
                                        const adult_count = room.adult_qty;
                                        const child_count =
                                          room.children?.length || 0;

                                        return (
                                          <div>
                                            {i > 0 && (
                                              <span className="mx-2">|</span>
                                            )}
                                            {Array(adult_count)
                                              .fill()
                                              .map((_, j) => (
                                                <svg
                                                  key={j}
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="16"
                                                  height="16"
                                                  fill="currentColor"
                                                  className="bi bi-person-fill"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                                </svg>
                                              ))}
                                            {Array(child_count)
                                              .fill()
                                              .map((_, j) => (
                                                <svg
                                                  key={j}
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="16"
                                                  height="16"
                                                  fill="currentColor"
                                                  className="bi bi-person-fill"
                                                  viewBox="0 0 16 16"
                                                  style={{ color: "#666666" }}
                                                >
                                                  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                                </svg>
                                              ))}
                                          </div>
                                        );
                                      });
                                    })()}
                                  </div>
                                    <div>
                                    <h5 style={{fontWeight:"500"}}>{roomobj.amenities.length>0?t("Facilities")+" :":""}</h5>   
                                  <div className="d-flex flex-wrap" >
                                  {
                                      roomobj.amenities.map((icon,icon_index)=>{
                                        
                                        if(icon_index< 14 && isNaN(parseInt(icon.icon))){
                                        return(
                                        <>
                                        {/* <div id={"hover_"+icon.icon}></div> */}
                                        <div style={{display:"inline-block",borderRadius:"5px",margin:"5px",marginTop:"0px",background:"#666666",height:"35px",width:"35px", color: "#e3e4e9",
    position: "relative"}} 
    title={icon.name}
    // onMouseLeave={(e)=>handleStopMessagePopup(e,icon.icon)} onMouseEnter={(e)=>{handleShowMessagePopup(e,icon.icon)}}
    >
                                          <img src={"https://stage-hotels.etm-system.ru/img/hotel-icons/"+icon.icon+".svg"} style={{height:"100%",width:"100%"}} alt="" />
                                        </div>
                                        </>
                                        )
                                        }
                                        if(roomobj.amenities.length-1===icon_index){
                                          return(
                                              <>
                                        <div style={{display:"inline-block",borderRadius:"5px",marginTop:"0px",background:"#a1a1a1ff",height:"35px",width:"35px", color: "#e3e4e9",
    position: "relative",cursor:'pointer'}} onClick={()=>{handleShowFacilities(roomobj.amenities)}}>
                                         <p style={{fontSize: "2.3rem",
    margin: "0px",
    textAlign: "center"}}>...</p>
                                        </div>
                                        </>
                                          )
                                        }
                                      }
                                    )
                                    
                                       
                                   
                                    }
                                  </div>

                                  </div>
                                </div>
                              </>
                            )
                          )}
                        </div>
                      </div>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            {JSON.parse(room.rooms).map(
                              (roomobj, desc_index) => (
                                <>
                                  <h4 style={{fontWeight:"normal"}}>
                                    {desc_index === 0
                                      ? roomobj?.description
                                      : ""}
                                  </h4>
                                </>
                              )
                            )}
                          </div>
                          <div className="col-md-4">
                            <div>
                              <h4 style={{ color: "#666666" }}>
                                {room?.cancel_policy?.free_cancel_date !==
                                null ? (
                                  <i
                                    className="fa fa-check "
                                    style={{
                                      border: "1px solid #666666",
                                      padding: "5px",
                                      marginRight: "10px",
                                      display: "inline-block",
                                      borderRadius: "50%",
                                    }}
                                  ></i>
                                ) : (
                                  <p
                                    className=""
                                    style={{
                                      border: "1px solid #666666",
                                      padding: "0px 8px",
                                      marginRight: "10px",
                                      display: "inline-block",
                                      borderRadius: "50%",
                                    }}
                                  >
                                    !
                                  </p>
                                )}
                                {room?.cancel_policy?.free_cancel_date !== null
                                 ? (lnstr=="en"? "Free cancellation":"الغاء الرسوم") : (lnstr=="en"? "Non-refundable fare":"غير مستردة")}
                              </h4>
                            </div>
                            <div>
                              <p>
                                {room?.cancel_policy?.free_cancel_date !== null
                                   ? (lnstr=="en"? "under ":"التاريخ ") +
                                    room?.cancel_policy?.free_cancel_date?.split(
                                      "T"
                                    )[0]
                                  : ""}
                              </p>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="text-center">
                              <h4>
                                {room?.price_per_currency.USD?.total + ".00"}
                                &nbsp;$
                              </h4>
                            </div>
                            <div>
                              <button
                                type="submit"
                                onClick={(e) => showPaymentPage(e, room.id)}
                                className="btn btn-primary"
                                style={{ width: "100%" }}
                              >
                                {t("Buy")}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ))}
              {hotellist.length === 0 && !loading && (
                <div>
                  <div className="text-center">
                    <i class="fas fa-search" style={{ fontSize: "30px" }}></i>
                  </div>
                  <div className="text-center mt-3">
                     <h4>{lnstr=="en"? "Nothing found":"لا يوجد نتائج"}</h4>
                    <h4>{lnstr=="en"?"Try changing the request parameter":"الرجاء تغيير معلومات البحث"}</h4>
                  </div>
                  <div className="text-center mt-3">
                    <Link to="/hotel-search">
                      <button className="btn-primary"> {lnstr=="en"? "Back to Search":"العودة للبحث"}</button>
                    </Link>
                  </div>
                </div>
              )}
            </Col>
            <Col md={1}></Col>
          </div>
        </div>
      </div>
         {
  isOpen &&
  currentHotelId &&
  roomImage[currentHotelId] &&
  roomImage[currentHotelId].length > 0 &&
  photoIndex < roomImage[currentHotelId].length && (
    <>
      <Lightbox
        mainSrc={roomImage[currentHotelId][photoIndex].url}
        nextSrc={roomImage[currentHotelId][(photoIndex + 1) % roomImage[currentHotelId].length]?.url}
        prevSrc={roomImage[currentHotelId][(photoIndex + roomImage[currentHotelId].length - 1) % roomImage[currentHotelId].length]?.url}
        onCloseRequest={() => setIsOpen(false)}
        onMovePrevRequest={() =>
          setPhotoIndex(
            (photoIndex + roomImage[currentHotelId].length - 1) %
              roomImage[currentHotelId].length
          )
        }
        onMoveNextRequest={() =>
          setPhotoIndex((photoIndex + 1) % roomImage[currentHotelId].length)
        }
        imageTitle={`${photoIndex + 1} / ${roomImage[currentHotelId].length}`}
        wrapperClassName="custom-lightbox"
      />
        <div
                  style={{
                    position: 'fixed',
                    bottom: 10,
                    left: 0,
                    right: 0,
                    padding: '10px 20px',
                    display: 'flex',
                    overflowX: 'auto',
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    zIndex: 1600,
                    gap: '10px',
                  }}
                >
                  {roomImage[currentHotelId]?.map((img, idx) => (
                    <img
                      key={idx}
                      src={img.url}
                      alt={`Thumb ${idx}`}
                      onClick={() => setPhotoIndex(idx)}
                      style={{
                        width: '80px',
                        height: '60px',
                        objectFit: 'cover',
                        border: idx === photoIndex ? '3px solid #00bfff' : '2px solid #666',
                        opacity: idx === photoIndex ? 1 : 0.6,
                        cursor: 'pointer',
                        borderRadius: '4px',
                        transition: 'all 0.2s ease-in-out',
                      }}
                    />
                  ))}
                </div>
    
      {/* thumbnail viewer stays same */}
    </>
  )
}
{
  (facilitiesPopup && amenities.length>0) &&
  
        <div className="modal">
          <div
            className="modal-content"
            style={{ height: "auto", width: "700px",textAlign:"start" }}
          >
            <h2>
              <span>
                {t("Room facilities")}
              </span>
            </h2>
            <div type="button" className={`position-absolute`} style ={{fontSize:"1.5rem",fontWeight:"400",top:"10px",right:lnstr==="en"&&"20px",left:lnstr==="ar"&&"20px"}} onClick={handleClose} >
              &times;
            </div>
            {/* <div style={{ height: "50px" }}></div> */}
            <div>
            <ul className="mx-5">
           {
            amenities.map((icon)=>{
              if(isNaN(parseInt(icon.icon)))
              return(
              <li className="text-start">{t(icon.name)}</li>
              )

           })
              
           }
           </ul>
           
            </div>
          </div>
        </div>
   
}
          
                
      <Footer />


      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </Fragment>
  );
}

export default ShowBuyHotel;
